import roles from "@/roles";
export default [
  {
    title: "Alliance",
    roles: [roles.ADMIN, roles.ALLIANCE],
    children: [
      {
        router: true,
        title: "Alliance Overview Map",
        to: "AllianceOverviewMap",
        roles: [roles.ADMIN, roles.ALLIANCE]
      }
    ]
  }
];
